import React from 'react';
import Products from '../Courses/Courses';
import Navigation from '../../Shared/Navigation/Navigation';

import Reviews from '../Reviews/Reviews';
import Banner from '../Banner/Banner';
import Footer from '../../Shared/Footer/Footer';
import PhotoAlbum from '../PhotoAlbum/PhotoAlbum';
import ChooseUs from '../ChooseUs/ChooseUs';
import Workshop from '../Workshop/Workshop';
import HowItWorks from '../HowItWorks/HowItWorks';


const Home = () => {
    return (
        <div>
            <Navigation></Navigation>
            <Banner></Banner>
            <Products></Products>
            <Workshop></Workshop>
            <ChooseUs></ChooseUs>
            <HowItWorks></HowItWorks>
            <Reviews></Reviews>
            <Footer></Footer>

        </div>
    );
};

export default Home;